module.exports = __webpack_public_path__ + "static/media/report_rephrase.52fc2d62.svg";